import React from 'react';
import { useNavigate } from 'react-router-dom';
import { RiArrowRightLine } from 'react-icons/ri';

const MainSection = () => {
  const navigate = useNavigate();

  return (
    <section className="lp-cta">
      <div className="lp-cta-inner lp-reveal">
        <h2>Déposez votre première facture en 30 secondes</h2>
        <p>
          Créez votre compte gratuitement, importez une facture et laissez
          Easy Compta remplir le reste. Vos rapports PDF suivent tout seuls.
        </p>
        <button
          type="button"
          className="lp-btn lp-btn-primary"
          onClick={() => navigate('/signup')}
        >
          Commencer gratuitement
          <RiArrowRightLine />
        </button>
      </div>
    </section>
  );
};

export default MainSection;
